module.exports = __webpack_public_path__ + "img/diashow (9).c3aef27.jpg";